/* eslint-disable @typescript-eslint/no-empty-function */
import XFormDialog from '@/components/x-form-dialog/XFormDialog.vue'
import { BaseForm } from './BaseForm'

export const enum EventName {
  SAVE_SUCCESS = 'saveSuccess',
  SAVE_FAIL = 'saveFail',
  LOAD_SUCCESS = 'loadSuccess',
  LOAD_FAIL = 'loadFail',
  OPEND = 'opend'
}

/**
 *表单
 * @export
 * @class EditForm
 */
export class FormDialog extends BaseForm {
  /**
   * 构造搜索表单
   * @param el 挂载节点
   * @param form 表单配置
   * @param title 对话框标题
   * @param footers 对话框底部按钮
   */
  constructor(
    el: Element,
    form: XFormProp,
    title?: string,
    footers?: Footer[],
    width?: string
  ) {
    super(el, XFormDialog, {
      form,
      title,
      footers,
      width
    })
  }

  /**
   * 保存
   *
   * @param success 保存成功后的回调
   * @param error 保存失败后的回调
   * @memberof FormDialog
   */
  save(success?: (formdata?: any) => void, error?: () => void) {
    if(this.controller) {
      return this.controller.save(success, error)
    }
  }

  /**
   * 保存时的额外参数
   */
  setSaveParams(data: any) {
    if(this.controller) {
      return this.controller.setSaveParams(data)
    }
  }

  /**
   * 自定义保存
   * @memberof FormDialog
   */
  get customSave() {
    if(this.handler) {
      return this.handler['customSave']
    }
  }

  set customSave(fn) {
    if(this.handler) {
      this.handler['customSave'] = fn
    }
  }

  /**
   * 打开对话框
   * @param data 加载数据的请求参数/初始表单值
   * @returns 
   */
  open(data?: any): Promise<boolean> {
    if(this.controller) {
      return this.controller.open(data)
    } else {
      return Promise.reject(false)
    }
  }

  /**
   * 关闭对话框
   * @returns 
   */
  close() {
    if(this.controller) {
      this.controller.close()
    }
  }

  /**
   * 显示加载状态
   */
  showLoading() {
    if(this.controller) {
      this.controller.showLoading()
    }
  }

  /**
   * 关闭加载状态
   */
   closeLoading() {
    if(this.controller) {
      this.controller.closeLoading()
    }
  }

  /**
   * 监听保存成功事件
   * @memberof EditForm
   */
  get onSaveSuccess(): ((formData: any) => void) | undefined {
      return this.handler[EventName.SAVE_SUCCESS]
  }

  set onSaveSuccess(fn) {
    this.handler[EventName.SAVE_SUCCESS] = fn
  }

  /**
   * 监听保存失败事件
   * @memberof EditForm
   */
  get onSaveFail(): (() => void) | undefined {
    return this.handler[EventName.SAVE_FAIL]
  }

  set onSaveFail(fn) {
    this.handler[EventName.SAVE_FAIL] = fn
  }

  /**
   * 监听加载成功事件
   * @memberof EditForm
   */
  get onLoadSuccess(): ((formData: any) => void) | undefined {
    return this.handler[EventName.LOAD_SUCCESS]
  }

  set onLoadSuccess(fn) {
    this.handler[EventName.LOAD_SUCCESS] = fn
  }

  /**
   * 监听加载失败事件
   * @memberof EditForm
   */
  get onLoadFail(): (() => void) | undefined {
    return this.handler[EventName.LOAD_FAIL]
  }

  set onLoadFail(fn) {
    this.handler[EventName.LOAD_FAIL] = fn
  }

  /**
   * 监听保存成功事件
   * @memberof EditForm
   */
  get onOpend(): (() => void) | undefined {
      return this.handler[EventName.OPEND]
  }

  set onOpend(fn) {
    this.handler[EventName.OPEND] = fn
  }
}

